<template>
  <z-form ref="form" class="mt-4">
    <transition name="fade" mode="out-in">
      <base-modal key="form">
        <template>
          <template slot="description">
            {{ $t('projects.imports.field.description') }}
          </template>
          <!-- <template slot="format">
            {{ $t('db.recipient.modal.import.required_format') }}
          </template> -->
          <template>
            <upload
              ref="upload"
              :format="formats"
              :accept="accept"
              :max-size="max_file_size"
              :action="url"
              :multiple="false"
              :before-upload="before_upload"
              type="drag"
            >
              <div style="padding: 20px 0">
                <icon type="ios-cloud-upload" size="52" style="color: #3399ff" />

                <p v-if="!is_loading" class="text-center text-muted">
                  {{ $t('shared.component.file_upload.drag') }}
                </p>

                <p v-else>{{ $t('shared.component.file_upload.file_loading') }}</p>
              </div>
            </upload>
          </template>
        </template>
        <template #footer-cancel="{ close }">
          <v-btn ref="close" class="btn-cancel hidden" color="#fff" @click="close()">
            {{ $t('shared.component.button.cancel') }}
          </v-btn>
        </template>
      </base-modal>
    </transition>
  </z-form>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { TasksService } from '@tasks/services/TasksService';
  import { API_URL } from '@shared/helpers/env';

  const formats = ['csv'];
  export default {
    components: {
      BaseModal
    },
    data() {
      return {
        file: '',
        file_name: '',
        file_preview: {},
        url: `${API_URL}/api/v1/tasks/import/file`,
        accept: formats.map((i) => `.${i}`).join(','),
        format_user: formats.map((i) => `.${i}`).join(', '),
        format: formats,
        is_loading: false,
        max_file_size: 20480,
        max_file_size_bytes: 20971520

      };
    },

    methods: {
      before_upload(file) {
        this.is_loading = true;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('project_id', this.$route.params.id);
        this.file_name = file.name;
        
        const valid_file = formats.filter((format) => file.name?.includes(`.${format}`))?.length > 0;

        if (file.size < this.max_file_size_bytes && valid_file) {
          this.file_preview = file;

          TasksService.uploadFile(this.$route.params.id, formData)
            .then((resp) => {
              this.$refs.close.$el.click();
              this.$router.push({
                name: 'projects.import.edit',
                params: {
                  project_id: this.$route.params.id,
                  file_id: resp.id,
                  file_name: this.file_name
                }
              });
            })
            .catch((error) => {
              this.$noty.server_error(error);
            });
        } else if (file.size > this.max_file_size_bytes) {
          const warning_msg = this.$t('core.document.error.max_size', { filename: file.name });
          this.$noty.warning(warning_msg);
        } else if (!valid_file) {
          this.$noty.warning(this.$t('shared.component.file_upload.invalid_format'));
        }
        return false;
      }
    }
  };
</script>

<style lang="scss"></style>
